"use client"

import PropTypes from "prop-types"
import ToolContainer from "./container"
import CardsSettings from "./cards/cardssettings"
import FlashCards from "./cards/flashcards"
import { useLanguage } from "../../../../contexts/LanguageContext"
import { Icons } from "../../../../components/Icons"

const Cards = ({ onExit }) => {
  const { t } = useLanguage()

  return (
    <div>
      <header className="toolswitcher">
        <h1>{t("flashCards")}</h1>
        <button onClick={() => onExit("main")} className="btn btn-secondary flex items-center space-x-2">
          <Icons.ArrowLeft className="w-4 h-4" />{t('trainings.back')}
        </button>
      </header>
      <ToolContainer
        settingsContainer={(action) => <CardsSettings onStart={action} />}
        processContainer={(action) => <FlashCards onFinish={action} />}
      />
    </div>
  )
}

Cards.propTypes = {
  onExit: PropTypes.func.isRequired,
}

export default Cards
